<template>
  <div class="grid">
    <div
      v-for="kachel in kacheln"
      :key="kachel.id"
      :class="['kachel', kachel.typ]"
    >
      <div class="inner-grid">
        <div :class="['cell', kachel.wochentag]">
          {{ kachel.datum  }}
        </div>
        <div class="cell">
          {{ kachel.wish }}
        </div>  
        <div class="cell">
          {{ kachel.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {computed, defineComponent, ref, watch} from "vue"
  import { GetEmployVacationDataDate } from "@/data/employData"
  import type { EmployVacationData, VacationData } from '@/types/firestore'
  import { convertUtcToGermanLocal} from "@/hooks/utils"
  import { GetVacationData } from "@/data/vacationData"
  
  interface Kachel {
    id: string
    datum:string
    typ: string
    wish: string
    text: string
    wochentag: string
  }

  export default defineComponent({
    components: {  },
    name: "VacationView",
    setup(props) {
      const vacationPeriod = computed(() => props.vacationPeriod)
      const userData = computed(() => props.userData)
      const userVacations = ref<EmployVacationData[]>([])
      const userVacationWishData = ref<VacationData>([])
      const kacheln = ref<Kachel[]>([])
      let dummycount = 0

      function isDateInPeriod(dateToCheck: string | Date, datefrom: string | Date, dateto: string | Date): boolean {
//        console.log("isDateInPeriod: ", dateToCheck, datefrom, dateto)
        if (datefrom === "" || dateto === "") {
          return false;
        }
        const check = new Date(dateToCheck);
        const from = new Date(datefrom);
        const to = new Date(dateto);
        return check >= from && check <= to;
      }

      function anfangKacheln(wochentagNummer: number, d: Date) {
        if (dummycount === 0) {
          for (let i = 1; i < wochentagNummer; i++) {
            dummycount++
            kacheln.value.push({
              id: `dummy-${i}-${d.toISOString().slice(0, 10)}`,
              datum: "",
              typ: "dummy",
              wish: "",
              text: "",
              wochentag: ""
            })
          }
        }
      }

      // Warten auf das Vorhandensein von wishPeriod und userData
      watch([vacationPeriod, userData], async ([newVacationPeriod, newUserData]) => {
        userVacations.value = []
        kacheln.value = []
        if (!newVacationPeriod || !newUserData?.EmployData?.emplno) {
            return;
        }
        const _datefrom = convertUtcToGermanLocal(newVacationPeriod.startDate)
        const _dateto = convertUtcToGermanLocal(newVacationPeriod.endDate)
        userVacations.value = await GetEmployVacationDataDate(newUserData.EmployData.emplno, _datefrom, _dateto)
        userVacationWishData.value = await GetVacationData(newVacationPeriod.year.toString(), newUserData.EmployData.emplno)
        const startDate = new Date(_datefrom)
        const endDate = new Date(_dateto)
        let _dummy = false
//        console.log("User Vacations: ", userVacations.value, userVacationWishData.value)
        for (let d: Date = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
          const _aktdate = d.toISOString().slice(0, 10)
//          console.log(d.toISOString().slice(0, 10))
          const vacationData: EmployVacationData | undefined = userVacations.value.find((vac: EmployVacationData) => vac.date_str === _aktdate)
          const entlastungstageWishData: string | undefined = userVacationWishData.value.reliefDays.find((et: string) => et === _aktdate)
          const prios = [isDateInPeriod(_aktdate, convertUtcToGermanLocal(userVacationWishData.value.priorityOne.startDate), convertUtcToGermanLocal(userVacationWishData.value.priorityOne.endDate)),
            isDateInPeriod(_aktdate, convertUtcToGermanLocal(userVacationWishData.value.priorityTwo.startDate), convertUtcToGermanLocal(userVacationWishData.value.priorityTwo.endDate)),
            isDateInPeriod(_aktdate, convertUtcToGermanLocal(userVacationWishData.value.priorityThree.startDate), convertUtcToGermanLocal(userVacationWishData.value.priorityThree.endDate)),
            isDateInPeriod(_aktdate, convertUtcToGermanLocal(userVacationWishData.value.priorityFour.startDate), convertUtcToGermanLocal(userVacationWishData.value.priorityFour.endDate))]
          const prioIndex = prios.findIndex(p => p === true)
//          console.log("Vacation Data: ", vacationData, entlastungstageWishData, prioIndex)
          const _datum = new Intl.DateTimeFormat("de-DE", {
            weekday: "short",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
            .format(new Date(d.toISOString().slice(0, 10)))
            .replace(",", "");
          const _wochentag = new Intl.DateTimeFormat("de-DE", { weekday: "short" })
            .format(new Date(d.toISOString().slice(0, 10)))
            .replace(",", "");
          const _wochentagNummer = new Date(d.toISOString().slice(0, 10)).getDay() === 0 ? 7 : new Date(d.toISOString().slice(0, 10)).getDay();
          if (vacationData != undefined)
          {
            anfangKacheln(_wochentagNummer, d)
            _dummy = true
            dummycount++
            let _typ = "frei"
            if (entlastungstageWishData != undefined) {
              _typ = "etfrei"
            }
            if (prioIndex >= 0) {
              _typ = "priofrei"
            }
            const _wish = prioIndex >= 0 ? `Prio ${prioIndex + 1}` : entlastungstageWishData != undefined ? "Entlastungstag" : ""
            const _ekz = vacationData?.kennz || ""
            
            kacheln.value.push({
              id: vacationData.id,
              datum: _datum,
              typ: _typ,
              wish: _wish,
              text: _ekz,
              wochentag: _wochentag
            })
          } else if (entlastungstageWishData != undefined) {
            anfangKacheln(_wochentagNummer, d)
            _dummy = true
            dummycount++
            const _typ = "etwunsch"
            const _wish = "Entlastungstag"
            const _ekz = "ET"
            kacheln.value.push({
              id: `wish-${d.toISOString().slice(0, 10)}`,
              datum: _datum,
              typ: _typ,
              wish: _wish,
              text: _ekz,
              wochentag: _wochentag
            })
          } else if (prioIndex >= 0) {
            anfangKacheln(_wochentagNummer, d)
            _dummy = true
            dummycount++
            const _typ = "freiwunsch"
            const _wish = `Prio ${prioIndex + 1}`
            const _ekz = ""
            kacheln.value.push({
              id: `prio-${d.toISOString().slice(0, 10)}`,
              datum: _datum,
              typ: _typ,
              wish: _wish,
              text: _ekz,
              wochentag: _wochentag
            })
          } else if (_dummy == true) {
            if (dummycount % 7 === 0) {
              kacheln.value.push({
                id: `dummy-${d.toISOString().slice(0, 10)}`,
                datum: "",
                text: "",
                wish: "",
                wochentag: "",
                typ: "dummy7"
              })
            } else {
              for (dummycount; dummycount < 7; dummycount++) {
                // Füge Dummy-Kacheln hinzu, um die Woche zu füllen
                kacheln.value.push({
                  id: `dummy-${dummycount}-${d.toISOString().slice(0, 10)}`,
                  datum: "",
                  typ: "dummy",
                  wish: "",
                  text: "",
                  wochentag: ""
                })
              }
              kacheln.value.push({
                id: `dummy-${d.toISOString().slice(0, 10)}`,
                datum: "",
                text: "",
                wish: "",
                wochentag: "",
                typ: "dummy7"
              })
            }
            _dummy = false
            dummycount = 0
          } 
        }
      }, { immediate: true })

      return {
        vacationPeriod,
        kacheln,
      }
    },
    props: {
      vacationPeriod: {
        type: Object,
        default: null,
      },
      userData: {
        type: Object,
        default: {},
      },
    },
    emits: ['dayclick'],
    methods: {
      dayClick(date) {
          this.$emit('dayclick', date);
      },
    }
  })
</script>
<style scoped>
/* Flexibles Grid-System */
.grid {
  display: grid;
  /*grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* Dynamische Spalten */
  grid-template-columns: repeat(7, 1fr); /* 7 Spalten auf Tablets */
  gap: 10px;
  padding: 20px;
  overflow-x: auto;
  white-space: nowrap;
}

/* Kachel-Design */
.kachel {
  /*height: 8.5em;*/
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3b82f6; /* Blau */
  font-weight: 450;
  /*font-size: 16px;*/
  font-size: 1.5vh; /* 1.2% der Bildschirmhöhe */
  color: black;
  aspect-ratio: 1.25 / 1; 
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.dummy {
  display: block;
  background-color: transparent !important;
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
.dummy7 {
  display: none;
}
/* Inneres Grid für 3x4 Layout in jeder Kachel */
.inner-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr); /* 1 Spalten */
  grid-template-rows: repeat(3, 1fr); /* 3 Zeilen */
  gap: 0px;
  width: 100%;
}

/* Einzelne Zelle in der Mini-Tabelle */
.cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border-radius: 1px;
}
.woche {
  color: black;
}
.samstag {
  color: blue;
}
.sonntag {
  color: red;
}
/* Verschiedene Hintergrundfarben nach Typ */
.etwunsch {
  background-color: orange /* #ff9800 */
}

.mittel {
  background-color: pink/* #e91e63 */
}

.spaet {
  background-color: purple/* #9c27b0 */
}

.freiwunsch {
  background-color: blue/* #2196f3 */
}

.etfrei {
  background-color: teal/* #009688 */
}

.priofrei {
  background-color: green/* #4caf50 */
}

.frei {
  background-color: grey 
}

.wunsch {
  background-color: #8b5cf6
}

.flex-scroll {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  white-space: nowrap;
  padding: 1px;
}

/* Responsiveness */
@media (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(4, 1fr); /* 2 Spalten auf Tablets */
  }

  .dummy7 {
    display: block;
    background-color: transparent !important;
    border-radius: 10px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    pointer-events: none;
  }
}

@media (max-width: 480px) {
  .kachel {
    font-size: 1.8vh; /* 1.8% der Bildschirmhöhe */
  }

  .grid {
    grid-template-columns: repeat(2, 1fr); /* 1 Spalte auf Handys */
  }

  .dummy7 {
    display: block;
    background-color: transparent !important;
    border-radius: 10px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    pointer-events: none;
  }
}
</style>